
class Facets {
  constructor() {
    this.productGrid = document.querySelector('[js-product-grid]');
    if (!this.productGrid) return;
    this.onResize = this.onResize.bind(this);
    this.onDocumentClick = this.onDocumentClick.bind(this);
    this.init();
  }

  isMobileViewport() {
    return window.innerWidth <= 768;
  }

  getGroupsContainer() {
    return this.productGrid.querySelector('.ird-facets__groups');
  }

  syncLenisPrevent() {
    const groups = this.getGroupsContainer();
    if (!groups) return;

    const hasOverflow = groups.scrollHeight > groups.clientHeight + 1;
    const shouldPrevent = this.isMobileViewport() && hasOverflow;

    if (shouldPrevent) {
      groups.setAttribute('data-lenis-prevent', '');
      return;
    }

    groups.removeAttribute('data-lenis-prevent');
  }

  onResize() {
    this.syncLenisPrevent();
  }

  onDocumentClick(e) {
    const sort = this.productGrid.querySelector('[js-product-grid-sort]');
    if (!sort) return;
    if (sort.contains(e.target)) return;
    sort.classList.remove('-open');
    const toggle = sort.querySelector('[js-product-grid-sort-toggle]');
    if (toggle) toggle.setAttribute('aria-expanded', 'false');
  }

  openActiveGroups() {
    this.productGrid.querySelectorAll('[js-facets-group-toggle]').forEach((btn) => {
      const panelId = btn.getAttribute('aria-controls');
      const panel = panelId ? document.getElementById(panelId) : null;
      if (panel && panel.querySelector('input:checked')) {
        btn.setAttribute('aria-expanded', 'true');
      }
    });
    this.syncLenisPrevent();
  }

  attachAccordions() {
    this.productGrid.querySelectorAll('[js-facets-group-toggle]').forEach((btn) => {
      btn.addEventListener('click', () => {
        const expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        requestAnimationFrame(() => {
          this.syncLenisPrevent();
          this.productGrid.dispatchEvent(new CustomEvent('ird:product-grid:sticky-refresh'));
        });
      });
    });
  }

  attachFilters() {
    const form = this.productGrid.querySelector('[js-facets-form]');
    if (!form) return;


    form.querySelectorAll('input[type="checkbox"]').forEach((checkbox) => {
      checkbox.addEventListener('change', () => this.submit(form));
    });

    form.addEventListener('submit', (e) => {
      e.preventDefault();
      this.submit(form);
    });

    this.productGrid.querySelectorAll('[js-facets-remove], [js-facets-link]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        this.fetchUrl(link.href);
      });
    });
  }

  attachSorting() {
    const form = this.productGrid.querySelector('[js-facets-form]');
    const sort = this.productGrid.querySelector('[js-product-grid-sort]');
    const toggle = this.productGrid.querySelector('[js-product-grid-sort-toggle]');
    if (!form || !sort || !toggle) return;

    toggle.addEventListener('click', () => {
      const nextOpen = !sort.classList.contains('-open');
      sort.classList.toggle('-open', nextOpen);
      toggle.setAttribute('aria-expanded', String(nextOpen));
    });

    const currentEl = toggle.querySelector('.ird-product-grid__sort-current');

    sort.querySelectorAll('[js-product-grid-sort-link]').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        const sortValue = link.getAttribute('data-sort-value');
        if (!sortValue) return;
        sort.classList.remove('-open');
        toggle.setAttribute('aria-expanded', 'false');
        if (currentEl) currentEl.textContent = link.textContent.trim();

        const params = new URLSearchParams(new FormData(form));
        params.set('sort_by', sortValue);
        params.delete('page');
        const queryString = params.toString();
        const url = queryString ? `${form.action}?${queryString}` : form.action;
        this.fetchUrl(url);
      });
    });
  }

  attachPagination() {
    this.productGrid.querySelectorAll('.ird-product-grid__pagination a[href]').forEach((link) => {
      link.addEventListener('click', (e) => {
        if (e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || e.button !== 0) return;
        e.preventDefault();
        this.fetchUrl(link.href);
      });
    });
  }

  submit(form) {
    const params = new URLSearchParams(new FormData(form));
    params.delete('page');
    const queryString = params.toString();
    const url = queryString ? `${form.action}?${queryString}` : form.action;
    this.fetchUrl(url);
  }

  fetchUrl(url) {
    this.productGrid.classList.add('-loading');

    fetch(url)
      .then((r) => r.text())
      .then((html) => {
        const doc = new DOMParser().parseFromString(html, 'text/html');
        const newGrid = doc.querySelector('[js-product-grid]');
        if (newGrid) {
          this.productGrid.innerHTML = newGrid.innerHTML;
          this.productGrid.dispatchEvent(new CustomEvent('ird:product-grid:updated'));
        }
        window.history.pushState({}, '', url);
        const top = this.productGrid.getBoundingClientRect().top + window.scrollY - 44;
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
        this.attachAccordions();
        this.attachFilters();
        this.attachSorting();
        this.attachPagination();
        this.openActiveGroups();
      })
      .catch((err) => console.error('Facets error:', err))
      .finally(() => this.productGrid.classList.remove('-loading'));
  }

  init() {
    this.attachAccordions();
    this.attachFilters();
    this.attachSorting();
    this.attachPagination();
    this.openActiveGroups();
    window.addEventListener('resize', this.onResize);
    document.addEventListener('click', this.onDocumentClick);
    this.syncLenisPrevent();
  }
}

export default Facets;
